import React from "react"
import classNames from "classnames"

function Titlebar(props) {
  const { title, subtitle, desc, label, right, addons, className, rightClassName } = props
  const descText = desc || subtitle
  return (
    <div
      className={classNames("titlebar", className, {
        "with-addons": addons,
        "with-subtitle": descText,
      })}
    >
      <h3 className="title">{title || label}</h3>
      {descText && <div className="subtitle">{descText}</div>}
      {right && <div className={classNames("titlebar-right", rightClassName)}>{right}</div>}
      {addons ? addons : null}
    </div>
  )
}
export default Titlebar
